import React from 'react'
import { Stack } from '@mui/material'
import {
  SectionWrapper,
  SectionHeaderData,
  SectionHeader,
} from '@components/common'
import { CustomStyles } from '@utils/styles'
import { InfiniteSlideImage } from '../InfiniteSlideImage'
import {
  TestimonialCard,
  TestimonialCardProps,
} from '../ReviewsSection/PeopleCard'
import defaultStyles, { StyleClassNames } from './styles'

export type TestimonialSlideSectionData = {
  sectionHeaderData: SectionHeaderData
  cardData?: TestimonialCardProps[]
  darkBg?: boolean
}

export type TestimonialSlideSectionProps = TestimonialSlideSectionData & {
  csx?: CustomStyles<StyleClassNames>
  showDivider?: 'top' | 'bottom' | 'both' | 'none'
  alternateSectionBg?: boolean
}

export function TestimonialSlideSection({
  sectionHeaderData,
  cardData,
  showDivider,
  alternateSectionBg = false,
  darkBg = false,
}: TestimonialSlideSectionProps) {
  return (
    <SectionWrapper
      alternateBg={darkBg}
      showDivider={showDivider}
      alternateSectionBg={alternateSectionBg}
    >
      <Stack
        spacing={4}
        sx={{
          '.slideContainer': {
            marginInline: '12px !important',
          },
        }}
      >
        <SectionHeader {...sectionHeaderData} darkBg={darkBg} />
        <InfiniteSlideImage
          animationSpeed={16}
          disablePadding
          csx={{
            slidesContainer: defaultStyles.scrollWrapper,
          }}
          darkBg={darkBg}
        >
          {cardData?.map((card, index) => (
            <TestimonialCard
              key={index}
              {...card}
              darkBg={darkBg}
              csx={{
                card: {
                  width: {
                    xs: '300px',
                    sm: '400px',
                  },
                  minWidth: 'unset',
                  maxWidth: 'none',
                  marginInline: 'auto',
                  flexShrink: 0,
                },
              }}
            />
          ))}
        </InfiniteSlideImage>
      </Stack>
    </SectionWrapper>
  )
}
